// extracted by mini-css-extract-plugin
module.exports = {"cursor":"cursor-module--cursor--1P1y6","hand":"cursor-module--hand--2L66e","hold":"cursor-module--hold--zicgU"};